import { render, staticRenderFns } from "./Spreadsheet.vue?vue&type=template&id=76af024a&scoped=true&"
import script from "./Spreadsheet.vue?vue&type=script&lang=js&"
export * from "./Spreadsheet.vue?vue&type=script&lang=js&"
import style0 from "./Spreadsheet.vue?vue&type=style&index=0&id=76af024a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af024a",
  null
  
)

export default component.exports